<div class="container">
    <a class="navbar-brand" routerLink="/">
      <img alt="Main Markrrr Logo" style="height:80px" src="../assets/main-logo.png">
    </a> 
    <div id="right-container">
      <!-- <p class="list-item" style="margin-right: 20px;" [matMenuTriggerFor]="menu">Calculators</p> -->
      <!-- <p class="list-item">Enquiries</p> -->
    </div>
    <mat-menu #menu="matMenu">
      <button mat-menu-item>
        <span>Repayment Mortgage</span>
      </button>
      <button mat-menu-item>
        <span>Interest Only Mortgage</span>
      </button>
      <button mat-menu-item>
        <span>Buy To Let Mortgage</span>
      </button>
      <button mat-menu-item>
        <span>Land Duty Stamp Tax</span>
      </button>
      <button mat-menu-item>
        <span>Capital Gains Tax</span>
      </button>
    </mat-menu>
</div>
